import React from "react";

import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Skeleton from "@material-ui/lab/Skeleton";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";

import { makeStyles } from "@material-ui/core/styles";
import { green, grey } from '@material-ui/core/colors';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import moment from 'moment';

import Rating from '@material-ui/lab/Rating';
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
    on: {
        color: green[600],
        fontSize: '20px'
    },
    off: {
        color: grey[600],
        fontSize: '20px'
    },
    pointer: {
        cursor: "pointer"
    },
    tableContainer: {
        borderRadius: "8px",
        overflow: "hidden",
        backgroundColor: "transparent",
        boxShadow: "none",
        border: "none",
    },
    tableHeaderCell: {
        fontWeight: "bold",
        backgroundColor: "#1e1e1e",
        color: "#fff",
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        position: "sticky",
        top: 0,
        padding: "10px 16px",
    },
}));

export function RatingBox({ rating }) {
    const ratingTrunc = rating === null ? 0 : Math.trunc(rating);
    return <Rating
        defaultValue={ratingTrunc}
        max={3}
        readOnly
    />
}

export default function TableAttendantsStatus(props) {
    const { loading, attendants } = props
    const classes = useStyles();

    function renderList() {
        return attendants.map((a, k) => (
            <TableRow key={k}>
                <TableCell>
                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                        <span style={{ fontWeight: 500 }}>{a.name}</span>
                        <Chip
                            label={a.profile === "admin" ? i18n.t("dashboard.users.admin") : i18n.t("dashboard.users.agent")}
                            size="small"
                            style={{
                                height: 20,
                                fontSize: "0.72rem",
                                fontWeight: "bold",
                                textTransform: "capitalize",
                                backgroundColor: a.profile === "admin" ? "rgba(156, 39, 176, 0.15)" : "rgba(33, 150, 243, 0.15)",
                                color: a.profile === "admin" ? "#ba68c8" : "#2196f3",
                                border: a.profile === "admin" ? "1px solid rgba(156, 39, 176, 0.4)" : "1px solid rgba(33, 150, 243, 0.4)",
                            }}
                        />
                    </Box>
                </TableCell>
                {/* <TableCell align="center" title="1 - Insatisfeito, 2 - Satisfeito, 3 - Muito Satisfeito" className={classes.pointer}>
                    <RatingBox rating={a.rating} />
                </TableCell> */}
                <TableCell align="center">{a.rating}</TableCell>
                <TableCell align="center">{a.countRating}</TableCell>
                <TableCell align="center">{a.tickets}</TableCell>
                <TableCell align="center">{formatTime(a.avgWaitTime, 2)}</TableCell>
                <TableCell align="center">{formatTime(a.avgSupportTime, 2)}</TableCell>
                <TableCell align="center">
                    {a.online ?
                        <Tooltip title="Online">
                            <CheckCircleIcon className={classes.on} />
                        </Tooltip>
                        :
                        <Tooltip title="Offline">
                            <ErrorIcon className={classes.off} />
                        </Tooltip>
                    }
                </TableCell>
            </TableRow>
        ))
    }

    function formatTime(minutes) {
        if (minutes === undefined || minutes === null || isNaN(minutes)) return "00h 00m 00s";
        const totalSeconds = Math.round(Number(minutes) * 60);
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;
        return `${String(h).padStart(2, "0")}h ${String(m).padStart(2, "0")}m ${String(s).padStart(2, "0")}s`;
    }

    return (!loading ?
        <TableContainer className={classes.tableContainer}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.tableHeaderCell}>{i18n.t("dashboard.users.name")}</TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">{i18n.t("dashboard.assessments.score")}</TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">{i18n.t("dashboard.assessments.ratedCalls")}</TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">{i18n.t("dashboard.assessments.totalCalls")}</TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">{i18n.t("dashboard.cards.averageWaitingTime")}</TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">{i18n.t("dashboard.cards.averageServiceTime")}</TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">{i18n.t("dashboard.cards.status")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {renderList()}
                </TableBody>
            </Table>
        </TableContainer>
        : <Skeleton variant="rect" height={150} />
    )
}